module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/2_ebe0c8d86e2c7f85138455df5113ae1e.jpg";